module.exports = __webpack_public_path__ + "static/media/119.19978c4c.svg";